/* ASLANYM Astra — original progressive storefront behavior. No price calculations. */
(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('AstraConfig')?.textContent || '{}');
  const root = (config.root || '/').replace(/\/?$/, '/');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const q = (selector, parent = document) => parent.querySelector(selector);
  const qa = (selector, parent = document) => Array.from(parent.querySelectorAll(selector));
  const status = message => { const node = q('#AstraStatus'); if (node) node.textContent = message; };
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const path = url => new URL(url, location.origin);
  const delay = (fn, ms) => { let timer; return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), ms); }; };
  let lockedScroll = 0;
  let previousFocus = null;
  let cartBusy = false;
  let zoomReturn = null;
  const dialogTimers = new WeakMap();
  const active = () => q('dialog[open]');
  function unlock() {
    if (active()) return;
    document.body.classList.remove('is-locked');
    document.body.style.top = '';
    window.scrollTo(0, lockedScroll);
  }
  function closeDialog(dialog, instant = false) {
    if (!dialog?.open || dialogTimers.has(dialog)) return;
    const finish = () => {
      dialogTimers.delete(dialog);
      dialog.classList.remove('is-closing');
      if(!dialog.open)return;
      dialog.close();
      if(dialog.id==='ImageZoom' && zoomReturn?.dialog.isConnected){
        const returnTo=zoomReturn;
        zoomReturn=null;
        returnTo.dialog.showModal();
        returnTo.focus?.focus({preventScroll:true});
        return;
      }
      unlock();
      if(!active() && previousFocus?.isConnected)previousFocus.focus({preventScroll:true});
    };
    if (instant || reduced.matches || document.body.dataset.motion === 'false') finish();
    else { dialog.classList.add('is-closing'); dialogTimers.set(dialog,setTimeout(finish,240)); }
  }
  function openDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog?.showModal) return false;
    clearTimeout(dialogTimers.get(dialog));
    dialogTimers.delete(dialog);
    dialog.classList.remove('is-closing');
    if (dialog.open) return true;
    const old = active();
    if(id==='ImageZoom' && old)zoomReturn={dialog:old,focus:trigger};
    else zoomReturn=null;
    if (!old) {
      previousFocus = trigger || document.activeElement;
      lockedScroll = window.scrollY;
      document.body.style.top = `${-lockedScroll}px`;
      document.body.classList.add('is-locked');
    } else {
      clearTimeout(dialogTimers.get(old));
      dialogTimers.delete(old);
      old.classList.remove('is-closing');
      old.close();
    }
    qa('.mega-menu[open]').forEach(el => { el.open = false; });
    dialog.showModal();
    const focus = q('input[type="search"]', dialog) || q('[data-close]', dialog);
    focus?.focus({preventScroll:true});
    return true;
  }
  qa('dialog').forEach(dialog => {
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(dialog); });
    dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) closeDialog(dialog); });
  });
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-close]');
    if (close) { event.preventDefault(); closeDialog(close.closest('dialog')); return; }
    const trigger = event.target.closest('[data-open]');
    if (trigger && openDialog(trigger.dataset.open, trigger)) event.preventDefault();
    const step = event.target.closest('[data-qty-step]');
    if (step) {
      const input = q('input', step.closest('.quantity-control'));
      const direction = Number(step.dataset.qtyStep);
      if (direction > 0) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }
    const thumb = event.target.closest('[data-gallery-target]');
    if (thumb) { event.preventDefault(); showMedia(thumb.closest('[data-product-root]'), thumb.dataset.galleryTarget); }
    const zoom = event.target.closest('[data-zoom]');
    if (zoom) {
      event.preventDefault();
      const image = new Image(); image.src = zoom.dataset.zoom; image.alt = q('img', zoom)?.alt || '';
      q('[data-zoom-content]').replaceChildren(image); openDialog('ImageZoom', zoom);
    }
    const sticky = event.target.closest('[data-sticky-add]');
    if (sticky) {
      const productRoot = sticky.closest('[data-product-root]');
      const form = q('[data-product-form]', productRoot);
      const button = q('[data-add-button]', form);
      if (button && !button.disabled) form.requestSubmit(button);
      else q('.option-selectors', productRoot)?.scrollIntoView({block:'center',behavior:reduced.matches?'auto':'smooth'});
    }
    if (!event.target.closest('.mega-menu')) qa('.mega-menu[open]').forEach(menu => { menu.open = false; });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') qa('.mega-menu[open]').forEach(menu => { menu.open = false; q('summary',menu)?.focus(); }); });

  function setCartCount(count) { qa('[data-cart-count]').forEach(node => { node.textContent = count; }); }
  function replaceCart(html) {
    if (!html) return false;
    const newContent = q('[data-cart-content]', parse(html));
    if (!newContent) return false;
    const drawerContent = q('#CartDrawer [data-cart-content]');
    drawerContent?.replaceWith(newContent.cloneNode(true));
    setCartCount(newContent.dataset.count);
    return true;
  }
  async function refreshCart() {
    const url = path(config.cart || `${root}cart`); url.searchParams.set('section_id','astra-cart-drawer');
    const response = await fetch(url, {headers:{'Accept':'text/html'}});
    if (!response.ok) throw new Error(config.error);
    replaceCart(await response.text());
  }
  function replaceFullCartContent(incoming) {
    const current=q('.main-cart [data-cart-content]');
    if(!incoming || !current)return;
    const note=q('[name="note"]',current);
    const nextNote=q('[name="note"]',incoming);
    if(note && nextNote){
      nextNote.value=note.value;
      nextNote.closest('details').open=note.closest('details').open;
    }
    current.replaceWith(incoming);
  }
  async function refreshFullCart() {
    if (!q('.main-cart')) return;
    const url=path(config.cart || `${root}cart`); url.searchParams.set('section_id','astra-main-cart');
    const response=await fetch(url); if(!response.ok) return;
    const content=q('.main-cart [data-cart-content]',parse(await response.text()));
    replaceFullCartContent(content);
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    const button = q('[data-add-button]',form);
    const error = q('[data-form-error]',form);
    if (!q('[name="id"]',form)?.value || button.disabled) return;
    form.dataset.submitting='true'; button.disabled=true; button.setAttribute('aria-busy','true'); error.textContent='';
    const productRoot=form.closest('[data-product-root]');
    qa('[data-sticky-add]',productRoot).forEach(node=>node.disabled=true);
    try {
      const body = new FormData(form);
      body.set('sections','astra-cart-drawer'); body.set('sections_url',config.cart || `${root}cart`);
      const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Accept':'application/json'},body});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || config.error);
      if (!replaceCart(result.sections?.['astra-cart-drawer'])) {
        try { await refreshCart(); } catch { location.href=config.cart || `${root}cart`; return; }
      }
      status(config.added); openDialog('CartDrawer',button);
      await refreshFullCart();
    } catch(errorValue) { error.textContent=errorValue.message || config.error; status(error.textContent); }
    finally { form.dataset.submitting='false'; button.disabled=false; button.removeAttribute('aria-busy'); qa('[data-sticky-add]',productRoot).forEach(node=>node.disabled=false); }
  });
  async function changeCart(line, quantity) {
    if (cartBusy || !Number.isInteger(quantity) || quantity<0) return;
    cartBusy=true;
    const container=line.closest('[data-cart-content]');
    const surface=container.closest('.main-cart') || container.closest('dialog');
    const focused=document.activeElement;
    const focusKind=focused?.matches('[data-cart-quantity]') ? '[data-cart-quantity]' : focused?.matches('[data-cart-delta="1"]') ? '[data-cart-delta="1"]' : focused?.matches('[data-cart-delta="-1"]') ? '[data-cart-delta="-1"]' : focused?.matches('[data-cart-remove]') ? '[data-cart-remove]' : null;
    const lineKey=line.dataset.lineKey;
    const previousQuantity=Number(q('[data-cart-quantity]',line)?.defaultValue || 1);
    qa('button,input',container).forEach(node=>node.disabled=true);
    const error=q('[data-cart-error]',container); if(error) error.textContent='';
    try {
      const response = await fetch(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.dataset.lineKey,quantity,sections:['astra-cart-drawer','astra-main-cart'],sections_url:config.cart || `${root}cart`})});
      const result=await response.json();
      if(!response.ok || result.status) throw new Error(result.description || result.message || config.error);
      if(!replaceCart(result.sections?.['astra-cart-drawer'])) await refreshCart();
      const full=result.sections?.['astra-main-cart'];
      if(full && q('.main-cart')) { const incoming=q('.main-cart [data-cart-content]',parse(full)); replaceFullCartContent(incoming); }
      if(focusKind && !focused.isConnected){
        const updated=qa('[data-line-key]',surface).find(el=>el.dataset.lineKey===lineKey);
        const target=(updated && q(focusKind,updated)) || q('[data-cart-quantity],.checkout-button,.cart-empty a',surface);
        target?.focus({preventScroll:true});
      }
      status(`${result.item_count} ${result.item_count === 1 ? 'item' : 'items'}`);
    } catch(e) { if(error) error.textContent=e.message || config.error; const input=q('[data-cart-quantity]',line); if(input) input.value=previousQuantity; }
    finally { qa('button,input',container).forEach(node=>node.disabled=false); cartBusy=false; }
  }
  document.addEventListener('click', event => {
    const remove=event.target.closest('[data-cart-remove]');
    const delta=event.target.closest('[data-cart-delta]');
    if(remove){event.preventDefault();changeCart(remove.closest('[data-line-key]'),0);}
    if(delta){const line=delta.closest('[data-line-key]');const input=q('[data-cart-quantity]',line);changeCart(line,Math.max(0,Number(input.value)+Number(delta.dataset.cartDelta)*Number(input.step || 1)));}
  });
  document.addEventListener('change', event => {
    if(event.target.matches('[data-cart-quantity]')) changeCart(event.target.closest('[data-line-key]'),Number(event.target.value));
    if(event.target.matches('[data-auto-submit]')) event.target.form.requestSubmit();
  });
  document.addEventListener('click', event => { if(event.target.closest('[data-open="CartDrawer"]')) refreshCart().catch(()=>{}); });

  let quickRequest;
  document.addEventListener('click', async event => {
    const link=event.target.closest('[data-quick-url]');if(!link) return;
    event.preventDefault();quickRequest?.abort();quickRequest=new AbortController();
    const content=q('[data-quick-content]');content.textContent=config.loading;openDialog('QuickBuy',link);
    try {
      const url=path(link.dataset.quickUrl);url.searchParams.set('section_id','astra-quick-product');
      const response=await fetch(url,{signal:quickRequest.signal});if(!response.ok)throw new Error(config.error);
      const incoming=q('[data-product-root]',parse(await response.text()));if(!incoming)throw new Error(config.error);
      content.replaceChildren(incoming);initializeProducts(incoming.parentNode);applySwatches(incoming);
    } catch(e){if(e.name==='AbortError')return;content.textContent=config.error;const fallback=document.createElement('a');fallback.className='text-link';fallback.href=link.href;fallback.textContent=link.closest('[data-card]')?.querySelector('h3')?.textContent || 'View product';content.append(fallback);}
  });
  const variantRequests=new WeakMap();
  document.addEventListener('change',async event=>{
    const option=event.target.closest('[data-option-value-id]');if(!option)return;
    const productRoot=option.closest('[data-product-root]');const controller=new AbortController();variantRequests.get(productRoot)?.abort();variantRequests.set(productRoot,controller);
    const info=q('[data-product-info]',productRoot);info.setAttribute('aria-busy','true');q('[data-add-button]',info).disabled=true;
    qa('[data-sticky-add]',productRoot).forEach(node=>node.disabled=true);
    const values=qa('[data-option-value-id]:checked',productRoot).map(el=>el.dataset.optionValueId);
    const url=path(option.dataset.productUrl || productRoot.dataset.productUrl);url.searchParams.set('option_values',values.join(','));url.searchParams.set('section_id',productRoot.dataset.sectionId);
    try{
      const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw new Error(config.error);
      const incoming=parse(await response.text());const nextInfo=q('[data-product-info]',incoming);if(!nextInfo)throw new Error(config.error);
      const focusId=option.id;
      const oldQuantity=q('[name="quantity"]',info)?.value;
      const openAccordions=qa('.accordion',info).map(el=>el.open);
      info.replaceWith(nextInfo);applySwatches(nextInfo);
      qa('.accordion',nextInfo).forEach((el,i)=>{if(openAccordions[i]!==undefined)el.open=openAccordions[i];});
      const newQty=q('[name="quantity"]',nextInfo);if(newQty && Number(oldQuantity)>=Number(newQty.min || 1))newQty.value=oldQuantity;
      document.getElementById(focusId)?.focus({preventScroll:true});
      showMedia(productRoot,nextInfo.dataset.selectedMedia,false);
      if(productRoot.dataset.quick!=='true'){
        const nextUrl=new URL(location.href);nextUrl.searchParams.delete('option_values');if(nextInfo.dataset.variantId)nextUrl.searchParams.set('variant',nextInfo.dataset.variantId);else{nextUrl.searchParams.delete('variant');nextUrl.searchParams.set('option_values',values.join(','));}history.replaceState({},'',nextUrl);
        const newSticky=q('[data-sticky-purchase]',incoming);const sticky=q('[data-sticky-purchase]',productRoot);if(sticky && newSticky){newSticky.classList.toggle('is-visible',sticky.classList.contains('is-visible'));sticky.replaceWith(newSticky);}
      }
      bindSticky(productRoot);status(q('[data-selected-option]',nextInfo)?.textContent || '');
    }catch(e){if(e.name==='AbortError')return;const error=q('[data-form-error]',productRoot);if(error)error.textContent=config.error;info.removeAttribute('aria-busy');/* Keep purchase disabled until a valid server response resolves the variant. */}
  });
  function showMedia(productRoot,id,smooth=true){
    if(!productRoot || !id)return;const track=q('[data-gallery]',productRoot);const slide=qa('[data-media-id]',productRoot).find(el=>el.dataset.mediaId===String(id));
    if(!track || !slide)return;track.scrollTo({left:slide.offsetLeft-track.offsetLeft,behavior:smooth&&!reduced.matches?'smooth':'auto'});
    qa('[data-gallery-target]',productRoot).forEach(el=>{if(el.dataset.galleryTarget===String(id))el.setAttribute('aria-current','true');else el.removeAttribute('aria-current');});
    qa('video',track).forEach(video=>video.pause());
  }
  const stickyObservers=new WeakMap();
  function bindSticky(productRoot){
    stickyObservers.get(productRoot)?.disconnect();const form=q('[data-product-form]',productRoot);if(!form || !q('[data-sticky-purchase]',productRoot))return;
    const observer=new IntersectionObserver(entries=>{const sticky=q('[data-sticky-purchase]',productRoot);sticky?.classList.toggle('is-visible',!entries[0].isIntersecting && entries[0].boundingClientRect.bottom<window.innerHeight);},{threshold:0});observer.observe(form);stickyObservers.set(productRoot,observer);
  }
  function initializeProducts(scope=document){
    qa('[data-product-root]',scope).forEach(productRoot=>{
      if(productRoot.dataset.initialized)return;productRoot.dataset.initialized='true';
      requestAnimationFrame(()=>showMedia(productRoot,productRoot.dataset.selectedMedia,false));bindSticky(productRoot);
      const track=q('[data-gallery]',productRoot);
      track?.addEventListener('scroll',delay(()=>{const index=Math.round(track.scrollLeft/track.clientWidth);const slides=qa('[data-media-id]',track);qa('[data-gallery-target]',productRoot).forEach(el=>{if(el.dataset.galleryTarget===slides[index]?.dataset.mediaId)el.setAttribute('aria-current','true');else el.removeAttribute('aria-current');});},100),{passive:true});
    });
  }

  let searchRequest;
  const searchInput=q('[data-predictive-input]');
  const initialSuggestions=q('[data-predictive-results]')?.innerHTML || '';
  searchInput?.addEventListener('input',delay(async()=>{
    searchRequest?.abort();searchRequest=new AbortController();const results=q('[data-predictive-results]');const term=searchInput.value.trim();
    if(term.length<2){results.innerHTML=initialSuggestions;results.removeAttribute('aria-busy');return;}
    results.setAttribute('aria-busy','true');
    try{
      const url=path(`${root}search/suggest`);url.searchParams.set('q',term);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','5');url.searchParams.set('section_id','astra-predictive-search');
      const response=await fetch(url,{signal:searchRequest.signal});if(!response.ok)throw new Error(config.error);const incoming=q('.predictive-results',parse(await response.text()));if(incoming)results.replaceChildren(incoming);else throw new Error(config.error);
    }catch(e){if(e.name!=='AbortError'){results.textContent=config.error;const link=document.createElement('a');link.className='text-link';const url=path(config.search || `${root}search`);url.searchParams.set('q',term);url.searchParams.set('type','product');link.href=url;link.textContent='View search results';results.append(link);}}
    finally{results.removeAttribute('aria-busy');}
  },250));

  const colorMap={black:'#252523',white:'#f9f8f2','milky white':'#ede6d8',ivory:'#e9e0cd',beige:'#cdbc9e',brown:'#845335','light brown':'#b28a62','dark brown':'#573d30',coffee:'#614834',khaki:'#9f967b',green:'#728276','mint green':'#bacbbc',blue:'#536c82','royal blue':'#274b93',grey:'#929291',gray:'#929291','fairy pink':'#d8b5ba','light grey':'#c3c2c0',magenta:'#a74268',pink:'#d8b5ba','bean pink':'#bd979c',red:'#923c3c','wine red':'#662e3d',purple:'#8d768f',yellow:'#d5bf79'};
  function applySwatches(scope=document){qa('[data-color]',scope).forEach(node=>{const name=node.dataset.color.toLowerCase().trim();const color=colorMap[name];if(color)node.style.backgroundColor=color;else node.style.background='repeating-linear-gradient(45deg,#d7d5cf 0 3px,#f4f1ea 3px 6px)';});}
  const cardPreviews = new WeakMap();
  function initializeCards(scope=document) {
    qa('[data-card]',scope).forEach(card=>{
      if(card.dataset.cardInitialized)return;
      card.dataset.cardInitialized='true';
      const alternate=q('.card-image--second',card);
      if(!alternate)return;
      const ready=async()=>{
        if(!alternate.complete || !alternate.naturalWidth)return;
        try { await alternate.decode(); } catch { return; }
        if(alternate.naturalWidth)card.dataset.alternateReady='true';
      };
      alternate.addEventListener('load',ready);
      alternate.addEventListener('error',()=>{delete card.dataset.alternateReady;});
      ready();
    });
  }
  function previewSwatch(swatch) {
    const card=swatch.closest('[data-card]');
    if(!card)return;
    const state=cardPreviews.get(card) || {token:0};
    cardPreviews.set(card,state);
    const token=++state.token;
    const image=new Image();
    image.className='card-image card-image--swatch';
    image.alt='';
    image.decoding='async';
    image.onload=async()=>{
      try { await image.decode(); } catch { return; }
      if(state.token!==token || !image.naturalWidth)return;
      q('.card-image--swatch',card)?.remove();
      q('.card-image-link',card)?.append(image);
      card.classList.add('is-swatch-preview');
    };
    image.src=swatch.dataset.swatchImage;
  }
  function restoreSwatch(swatch) {
    const card=swatch.closest('[data-card]');
    const state=cardPreviews.get(card);
    if(state)state.token++;
    card?.classList.remove('is-swatch-preview');
  }
  document.addEventListener('pointerover',event=>{
    const swatch=event.target.closest('[data-swatch-image]');
    if(!swatch || swatch.contains(event.relatedTarget) || !matchMedia('(hover:hover) and (pointer:fine)').matches)return;
    previewSwatch(swatch);
  });
  document.addEventListener('pointerout',event=>{
    const swatch=event.target.closest('[data-swatch-image]');
    if(swatch && !swatch.contains(event.relatedTarget))restoreSwatch(swatch);
  });
  document.addEventListener('focusin',event=>{
    const swatch=event.target.closest('[data-swatch-image]');
    if(swatch)previewSwatch(swatch);
  });
  document.addEventListener('focusout',event=>{
    const swatch=event.target.closest('[data-swatch-image]');
    if(swatch)restoreSwatch(swatch);
  });
  let revealObserver;
  function enhance(scope=document){
    applySwatches(scope);initializeProducts(scope);initializeCards(scope);
    if(document.body.dataset.motion==='true'&&!reduced.matches){
      revealObserver ||= new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('will-reveal');revealObserver.unobserve(entry.target);}}),{threshold:.08});
      qa('[data-reveal]',scope).forEach(node=>{if(node.getBoundingClientRect().top>innerHeight){node.classList.add('will-reveal');revealObserver.observe(node);}});
    }
    qa('[data-recommendations]',scope).forEach(node=>{
      if(node.dataset.loaded)return;node.dataset.loaded='true';const observer=new IntersectionObserver(async entries=>{if(!entries[0].isIntersecting)return;observer.disconnect();try{const response=await fetch(node.dataset.url);if(!response.ok)return;const incoming=q('[data-recommendations]',parse(await response.text()));if(incoming){node.innerHTML=incoming.innerHTML;applySwatches(node);initializeCards(node);}}catch{/* Recommendations are non-blocking. */}},{rootMargin:'300px'});observer.observe(node);
    });
  }
  let ticking=false;
  function updateHeader(){q('[data-header]')?.classList.toggle('is-scrolled',window.scrollY>30);ticking=false;}
  window.addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(updateHeader);ticking=true;}},{passive:true});updateHeader();
  if(document.body.dataset.depth==='true' && document.body.dataset.motion==='true' && matchMedia('(hover:hover) and (pointer:fine)').matches && !reduced.matches){
    qa('.spotlight-image[data-depth-surface],.campaign-media[data-depth-surface]').forEach(node=>{let frame;node.addEventListener('pointermove',event=>{if(reduced.matches)return;cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const rect=node.getBoundingClientRect();node.style.setProperty('--ry',`${((event.clientX-rect.left)/rect.width-.5)*2}deg`);node.style.setProperty('--rx',`${-((event.clientY-rect.top)/rect.height-.5)*2}deg`);});});node.addEventListener('pointerleave',()=>{cancelAnimationFrame(frame);node.style.setProperty('--rx','0deg');node.style.setProperty('--ry','0deg');});});
  }
  reduced.addEventListener('change',()=>{if(reduced.matches){qa('.will-reveal').forEach(node=>node.classList.remove('will-reveal'));qa('[data-depth-surface]').forEach(node=>{node.style.removeProperty('--rx');node.style.removeProperty('--ry');});}});
  document.addEventListener('shopify:section:load',event=>enhance(event.target));
  document.addEventListener('shopify:section:select',event=>qa('.will-reveal',event.target).forEach(node=>node.classList.remove('will-reveal')));
  window.addEventListener('pageshow',()=>{if(!active())document.body.classList.remove('is-locked');refreshCart().catch(()=>{});});
  enhance();
})();
